import { Box, Stack, Switch, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import AWSIcon from './icons/aws.svg?react';
import GCPIcon from './icons/gcp-label.svg?react';

import './calculator.css';

function CalculatorProviderSelector({ selectedProvider, changeProvider }) {
  const isChecked = selectedProvider === 'AWS';

  function handleProviderChange(ev) {
    changeProvider(ev.target.checked ? 'AWS' : 'GCP');
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      className="provider-selector"
    >
      <Box
        className={`provider-box ${isChecked ? 'provider-box-inactive' : ''}`}
      >
        <GCPIcon className="provider-icon" />
        <Typography className="provider-label">Google Cloud</Typography>
      </Box>
      <Switch checked={isChecked} onChange={handleProviderChange} />
      <Box
        className={`provider-box ${isChecked ? '' : 'provider-box-inactive'}`}
      >
        <AWSIcon className="provider-icon" />
        <Typography className="provider-label">Amazon Cloud</Typography>
      </Box>
    </Stack>
  );
}

CalculatorProviderSelector.propTypes = {
  selectedProvider: PropTypes.oneOf(['AWS', 'GCP']).isRequired,
  changeProvider: PropTypes.func.isRequired,
};

export default CalculatorProviderSelector;
